import { selectApiData, selectApiNoContent } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { mapScheduleDtoToModel, mapScheduleModelToDto, ScheduleModel } from './dto/Schedule.dto';

export class ScheduleApi {
  constructor(private client: AxiosInstance) {}

  schedule(emailTemplateId: number, model: ScheduleModel): Promise<ScheduleModel> {
    const dto = mapScheduleModelToDto(model);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { lastSent, ...data } = dto;

    return this.client
      .post(`/api/v1/email-template/${emailTemplateId}/schedule`, data)
      .then(selectApiData)
      .then(mapScheduleDtoToModel);
  }

  scheduleRelativeDate(emailTemplateId: number, model: ScheduleModel): Promise<ScheduleModel> {
    return this.client
      .patch(`/api/v1/email-template/${emailTemplateId}/schedule-relative-date`, {
        scheduleRelativeDate: model.relativeDate,
      })
      .then(selectApiData)
      .then(mapScheduleDtoToModel);
  }

  updateInvitationSendTime(emailTemplateId: number, sendAtTime: string | null): Promise<void> {
    return this.client
      .patch(`/api/v1/email-template/${emailTemplateId}/invitation-send-time`, { sendAtTime })
      .then(selectApiData);
  }

  unschedule(emailTemplateId: number, scheduleId: number): Promise<void> {
    return this.client
      .delete(`/api/v1/email-template/${emailTemplateId}/schedule/${scheduleId}`)
      .then(selectApiNoContent);
  }
}
